import { string, type, TypeOf } from 'io-ts'
import { DateFromISOString } from 'io-ts-types'

export const TAuthResult = type({
  accessToken: string,
  accessTokenExpiredAt: DateFromISOString,
  refreshTokenExpiredAt: DateFromISOString,
  userId: string,
})

export type AuthResult = TypeOf<typeof TAuthResult>
